var map = {
	"./action_image.png": 59499,
	"./dimond.png": 9741,
	"./logo_01.png": 98136,
	"./logo_02.png": 6303,
	"./logo_03.png": 42767,
	"./logo_04.png": 19207,
	"./logo_05.png": 72141,
	"./p_feature1.png": 95800,
	"./prototype_banner_img.png": 51682,
	"./prototype_banner_img2.png": 67242,
	"./psd.png": 93749,
	"./saas.png": 31759,
	"./tab.png": 25250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60346;